import _typeof from "@babel/runtime/helpers/esm/typeof";
export default function getBorderRadius(borderRadius) {
  if (_typeof(borderRadius) === 'object') {
    var topLeft = borderRadius.topLeft,
        topRight = borderRadius.topRight,
        bottomLeft = borderRadius.bottomLeft,
        bottomRight = borderRadius.bottomRight;
    return {
      borderTopLeftRadius: topLeft,
      borderTopRightRadius: topRight,
      borderBottomLeftRadius: bottomLeft,
      borderBottomRightRadius: bottomRight
    };
  }

  return {
    borderRadius: borderRadius
  };
}